"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShiftHoursHeader = exports.ShiftHoursCell = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const utils_1 = require("@bemlo/utils");
const elements_1 = require("../../../elements");
const translate_1 = require("../../../translate");
const ShiftHoursBadge_1 = require("../atoms/ShiftHoursBadge");
const are_all_selected_1 = require("../utils/are-all-selected");
const IconGrid = (0, styled_1.default)(elements_1.Div)({
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridTemplateAreas: `"DAY EVENING NIGHT"`,
});
const ShiftHoursCell = ({ availableShiftHours, selectedShiftHours, setSelectedShiftHours, disabled, viewState, error, }) => {
    const toggleSelectedShiftHours = (shiftHours) => () => {
        if (selectedShiftHours.includes(shiftHours)) {
            setSelectedShiftHours?.(selectedShiftHours.filter((t) => t !== shiftHours));
        }
        else {
            setSelectedShiftHours?.([...selectedShiftHours, shiftHours]);
        }
    };
    return ((0, jsx_runtime_1.jsx)(IconGrid, { children: availableShiftHours.map((shiftHours) => ((0, jsx_runtime_1.jsx)(ShiftHoursBadge_1.ShiftHoursBadge, { error: error, checked: selectedShiftHours.includes(shiftHours), shiftHours: shiftHours, setChecked: viewState === 'edit'
                ? toggleSelectedShiftHours(shiftHours)
                : undefined, disabled: disabled }, shiftHours))) }));
};
exports.ShiftHoursCell = ShiftHoursCell;
const ShiftHoursHeader = ({ availabilities, viewState, updateShiftHours, }) => {
    const t = (0, translate_1.useTranslations)();
    if (viewState === 'view') {
        return (0, jsx_runtime_1.jsx)(elements_1.Text, { bold: true, children: t.common.time_of_day() });
    }
    const availableShiftHours = [
        ...new Set(availabilities.flatMap((a) => a.availableShiftHours)),
    ].filter(utils_1.isTruthy);
    const selectedAvailabilities = availabilities.filter((availability) => availability.selected);
    const shiftHoursSelectionStates = (0, are_all_selected_1.areAllShiftHoursSelected)(selectedAvailabilities);
    const toggleAllSelected = (shiftHours) => () => {
        const areAllSelected = shiftHoursSelectionStates[shiftHours].areAllSelected;
        updateShiftHours?.({
            action: areAllSelected ? 'remove' : 'add',
            shiftHours,
        });
    };
    return ((0, jsx_runtime_1.jsx)(IconGrid, { children: availableShiftHours.map((shiftHours) => ((0, jsx_runtime_1.jsx)(ShiftHoursBadge_1.ShiftHoursBadge, { checked: shiftHoursSelectionStates[shiftHours].areAllSelected &&
                shiftHoursSelectionStates[shiftHours].isSomeSelected, shiftHours: shiftHours, setChecked: toggleAllSelected(shiftHours), disabled: shiftHoursSelectionStates[shiftHours].disabled }, shiftHours))) }));
};
exports.ShiftHoursHeader = ShiftHoursHeader;
